export { NgTranscludeDirective } from './common';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/minimal/index.js
// module id = 1361
// module chunks = 31